/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation,
    getFullQuote,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step03 from '../components/Step03w'

const getAgreedItems = (agreeList: any) => {
    let agreedItems = [
        {
            type: 'fineWinesAndSpirits',
            text: 'Wine & Spirit – Bottles',
            items: [],
            apiName: 'fine_wines_and_spirits',
        },
        {
            type: 'collectiblesMemorabilia',
            text: 'Wine & Spirit – Casks',
            items: [],
            apiName: 'collectibles_memorabilia',
        },
    ]
    if (Object.values(agreeList).length) {
        for (const [left, right] of Object.entries(agreeList)) {
            let aindex = agreedItems.findIndex(a => a.apiName === left)
            if (aindex !== -1) {
                let arr: any[] = []
                Object.values(right).map((ai) => {
                    let sarr: any = {
                        title: ai.title,
                        insured: ai.insured,
                        agreed_value: ai.agreed_value,
                    }
                    arr.push(sarr)
                })
                let items = 'items'
                agreedItems[aindex][items] = arr
            }
        }
    }

    return agreedItems
}

const getUnspecifiedItems = (unspecifiedList) => {
    let unspecifiedItems = [
        {
            type: 'fineWinesAndSpirits',
            text: 'Wine & Spirit – Bottles',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'fine_wines_and_spirits',
        },
        {
            type: 'collectiblesMemorabilia',
            text: 'Wine & Spirit – Casks',
            marketValue: '0',
            sumInsured: 0,
            apiName: 'collectibles_memorabilia',
        },
    ]
    if (Object.values(unspecifiedList).length) {
        for (const [left, right] of Object.entries(unspecifiedList)) {
            let uindex = unspecifiedItems.findIndex(u => u.apiName === left)
            if (uindex !== -1) {
                let sumInsured = 'sumInsured'
                let marketValue = 'marketValue'
                unspecifiedItems[uindex][sumInsured] = right
                unspecifiedItems[uindex][marketValue] = right
            }
        }
    }
    return unspecifiedItems
}

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
        agreedItems: getAgreedItems(get(state.quote, 'full.response.quote.stockBusinessAssets.agreedItems', {})),
        unspecifiedItems: getUnspecifiedItems(
            get(state.quote, 'full.response.quote.stockBusinessAssets.unspecifiedItems', {})),
        editRenewals: true,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
        getFullQuote,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/containers/Step03w.tsx